import { AbstractControl } from '@angular/forms';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class SelectOptionsConsistencyController<T extends { [key: string]: any }> {
  private control: AbstractControl | null = null;
  private options: T[] = [];
  private selectedOptions: T[] = [];

  constructor(private optionValue: keyof T = 'value') { }

  setControl(control: AbstractControl | null): void {
    this.control = control;
  }

  getOptions(options: T[]): T[] {
    const selectedValuesSet = new Set(this.control?.value ?? []);
    this.selectedOptions = this.excludeDuplicates([...this.selectedOptions, ...this.options])
      .filter(option => selectedValuesSet.has(option[this.optionValue] as string));
    this.options = options;

    return this.calculateActualOptions(this.selectedOptions, this.options);
  }

  private excludeDuplicates(options: T[]): T[] {
    const t = (new Map(options.map(option => ([option[this.optionValue], option])))).values();
    return Array.from(t)
  }

  private calculateActualOptions(selectedOptions: T[], options: T[]): T[] {
    const optionSet = new Set(options.map(option => option[this.optionValue] as string));
    const restSelectedOptions = selectedOptions.filter(option => !optionSet.has(option[this.optionValue] as string));
    return [
      ...restSelectedOptions,
      ...options,
    ];
  }

}
